import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined
} from '@ant-design/icons'
import { Button, Form, Select, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { ACTION_MODE, PAGE_SIZE_OPTIONS } from '../../../../configData'
import {
  notificationDetail,
  notificationManagerAdd,
  notificationManagerUpdate,
  notificationStatus
} from '../../../../services/cmsservice'
import {
  footerAdd,
  footerDelete,
  footerPosition,
  listFooter,
  footerActive
} from '../../../../services/footer-service'
import { addressSearch } from '../../../../services/postservice'
import Card from '../../../Card'
import ModalCustom from '../../../common/Modal/ModalCustom'
import ModalConfirm, {
  showConfirm
} from '../../../common/ModalConfirm/ModalConfirm'
import TableField from '../../../common/Table/TableField'
import FormPost from './FormPost'
import { getSubProductType, ProductType } from '../../../PostManagement/configs'
import openNotification from '../../../common/Notification/openNotification '
import { getLabelByValue, hasPermission, removeVietnameseTones } from '../../../../config-func'

const OPTIONS = [
  {
    value: 1,
    label: 'Thuê'
  },
  {
    value: 2,
    label: 'Bán'
  }
]
const TableB = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [postType, setPostType] = useState('')
  const [typeRealEstate, setTypeRealEstate] = useState([])
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
    // city_code: '79'
  })

  const [cityCode, setCityCode] = useState()
  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  // async function fetchData() {
  //   setLoading(true)

  //   let _dataSource = []
  //   let _total = 0

  //   const params = {
  //     // page: filters.currentPage,
  //     // pageSize: filters.pageSize,
  //     active: true,
  //     tag: 2,
  //     city_code: filters.city_code || cityCode
  //   }

  //   const cleanedData = Object.fromEntries(
  //     Object.entries(params).filter(
  //       ([_, value]) => value !== '' && value !== null && value !== undefined
  //     )
  //   )

  //   try {
  //     const response = await listFooter(cleanedData)
  //     if (response?.data?.list?.[0]?.city_code) {
  //       setCityCode(response?.data?.list?.[0]?.city_code)
  //       getListDistricts(response?.data?.list?.[0]?.city_code)

  //       const sortedData = [...response?.data?.list].sort(
  //         (a, b) => a.position - b.position
  //       )

  //       _total = response?.data?.total
  //       _dataSource = sortedData
  //     } else {
  //       const params2 = {
  //         // page: filters.currentPage,
  //         // pageSize: filters.pageSize,
  //         tag: 2,
  //         city_code: '79'
  //       }

  //       const response2 = await listFooter(params2)
  //       setCityCode('79')
  //       getListDistricts('79')
  //       const sortedData = [...response2?.data?.list].sort(
  //         (a, b) => a.position - b.position
  //       )

  //       _total = response2?.data?.total
  //       _dataSource = sortedData
  //     }

  //     // }
  //   } catch (error) {
  //     console.error(error)
  //   } finally {
  //     setLoading(false)
  //     setTotal(_total)
  //     setDataSource(_dataSource)
  //   }
  // }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const baseParams = {
      tag: 2,
      city_code: filters.city_code || cityCode
    }

    // Nếu có city_code trong filters hoặc state thì chỉ gọi API 1 lần
    if (filters.city_code || cityCode) {
      await fetchListFooter(baseParams)
      return
    }

    // Nếu không có city_code, gọi API với active = true trước
    const hasData = await fetchListFooter({ ...baseParams, active: true })

    // Nếu lần 1 không có data, gọi API lần 2 với active = false và city_code = '79'
    if (!hasData) {
      await fetchListFooter({ tag: 2, active: false, city_code: '79' })
    }
  }

  // 🛠 Hàm gọi API và xử lý dữ liệu trả về
  async function fetchListFooter(params) {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(params).filter(
          ([_, value]) => value !== '' && value !== null && value !== undefined
        )
      )

      const response = await listFooter(cleanedData)

      if (response?.data?.list?.length) {
        const sortedData = response.data.list.sort(
          (a, b) => a.position - b.position
        )

        setTotal(response.data.total)
        setDataSource(sortedData)

        // Nếu có city_code từ API, cập nhật vào state
        if (response.data.list[0]?.city_code) {
          setCityCode(response.data.list[0].city_code)
          getListDistricts(response.data.list[0].city_code)
        } else {
          getListDistricts(cityCode)
        }

        return true // Có dữ liệu
      } else {
        setDataSource([])
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }

    return false // Không có dữ liệu
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, cityCode])
  // -=0-=0-====================================================================================================
  // Columns for Table

  const moveRecord = (id, direction) => {
    setDataSource((prevData) => {
      const index = prevData.findIndex((item) => item.id === id)
      if (index === -1) return prevData

      let newData = [...prevData]

      if (direction === 'up' && index > 0) {
        // Hoán đổi vị trí với phần tử phía trên
        ;[newData[index], newData[index - 1]] = [
          newData[index - 1],
          newData[index]
        ]
      } else if (direction === 'down' && index < prevData.length - 1) {
        // Hoán đổi vị trí với phần tử phía dưới
        ;[newData[index], newData[index + 1]] = [
          newData[index + 1],
          newData[index]
        ]
      }

      // Gửi API với danh sách ID đã sắp xếp
      const body = {
        ids: newData.map((item) => item.id)
      }
      footerPosition(body)

      return newData
    })
  }

  const initialColumns = [
    {
      title: 'STT',
      // dataIndex: 'id',
      // key: 'id'
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      render: (_, record) => {
        const option = OPTIONS.find((item) => item.value === record.label)
        console.log('option', option)
        return <>{option?.label}</>
      }
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      render: (_, record) => (
        <span>
          {ProductType.find((n) => n.value === record.post_type)?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình ',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      render: (_, record) => (
        <span>{getLabelByValue(record.type_real_estate)}</span>
      )
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'district_code',
      key: 'district_code',
      render: (_, record) => {
        return <>{record.district_info.name}</>
      }
    },

    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'city_code',
      key: 'city_code',
      render: (_, record) => {
        return <>{record.city_info.name}</>
      }
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      render: (_, record, index) => {
        return (
          <Space size="small">
            {hasPermission('P59.2', permissions) && (
            <Tooltip title="Xóa">
              <Button
                style={{ width: 32 }}
                icon={<DeleteOutlined style={{ color: 'red' }} />}
                onClick={() =>
                  showConfirm({
                    title: 'Xác nhận xóa',
                    content: (
                      <div>
                        Bạn có chắc chắn muốn xóa
                        {/* <b> {record.project_name}</b> không? */}
                      </div>
                    ),
                    onOk: () => handleDelete(record.id)
                  })
                }
              />
            </Tooltip>
            )}
            {/* <Tooltip title="Xóa">
              <Button
                icon={<VerticalAlignBottomOutlined />}
                onClick={() =>
                  showConfirm({
                    title: 'Xác nhận xóa',
                    content: (
                      <div>
                        Bạn có chắc chắn muốn xóa
                      </div>
                    ),
                    onOk: () => handleChangeStatus(2, record.id)
                  })
                }
              >
                Xuống
              </Button>
            </Tooltip>
            <Tooltip title="Xóa">
              <Button
                icon={<VerticalAlignTopOutlined />}
                onClick={() =>
                  showConfirm({
                    title: 'Xác nhận xóa',
                    content: (
                      <div>
                        Bạn có chắc chắn muốn xóa
                      </div>
                    ),
                    onOk: () => handleChangeStatus(2, record.id)
                  })
                }
              >
                Lên
              </Button>
            </Tooltip> */}
            {/* Nút xuống */}
            {index !== dataSource.length - 1 && hasPermission('P59.3', permissions) && (
              <Button
                icon={<VerticalAlignBottomOutlined />}
                onClick={() => moveRecord(record.id, 'down')}
              >
                Xuống
              </Button>
            )}

            {/* Nút lên */}
            {index !== 0 && hasPermission('P59.4', permissions) && (
              <Button
                icon={<VerticalAlignTopOutlined />}
                onClick={() => moveRecord(record.id, 'up')}
              >
                Lên
              </Button>
            )}
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const data = {
        ...values,
        tag: 2,
        city_code: filters.city_code || cityCode,
        position: 0,
        active: true
      }
      const res = await footerAdd(data)

      console.log('rerrrrrrr', res)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification('success', 'Tạo mới thành công !')
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handleChangeStatus = async (status, id) => {
    try {
      const res = await notificationStatus(status, id)
      if (res && res.data) {
        openNotification('success', 'Cập nhật thành công')
        fetchData()
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      console.log('err', err)
    }
  }

  // CITY
  const getListCities = async () => {
    try {
      const res = await addressSearch('', 'city')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))

      setCities(result)
    } catch (err) {}
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    // const code = cities.filter((item) => item.id == i)?.[0].code
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {}
  }
  // Danh sách phường xã
  const getListTowns = async (code) => {
    // const type = 'town'
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {}
  }

  useEffect(() => {
    getListCities()
  }, [])

  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      district_code: null,
      town_code: null
    })

    setFilters((prev) => ({
      ...prev,
      city_code: e
    }))
    setCityCode(e)
  }

  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    const type = getSubProductType(e)
    // const formattedArray = type?.map((item) => ({ value: item, label: item }))
    form.setFieldsValue({
      type_real_estate: null
    })
    setTypeRealEstate(type)
    setPostType(e)
  }

  // Xóa project
  const handleDelete = async (id) => {
    // const body = {
    //   ids: [ids]
    // }
    try {
      const res = await footerDelete(id)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const handleActive = async () => {
    const body = {
      city_code: cityCode,
      active: true,
      tag: 2
    }
    try {
      const res = await footerActive(body)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  return (
    <div>
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          <div style={{ fontSize: 20, fontWeight: 600 }}>
            Bất động sản {cities.filter((i) => i.code == cityCode)?.[0]?.name}
          </div>
          <div
            style={{
              marginLeft: 'auto',
              display: 'flex',
              gap: '8px',
              alignItems: 'center'
            }}
          >
            <span style={{ fontSize: 14 }}>Tỉnh/Thành phố</span>
            <Select
              value={cityCode}
              allowClear
              showSearch
              placeholder="Chọn Tỉnh/Thành phố"
              defaultValue="Hà Nội"
              style={{ width: 150 }}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
              onChange={onChangeCity}
            >
              {cities.map((item) => {
                return (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              })}
            </Select>
            {hasPermission('P59.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
            )}
            {!dataSource.length == 0 && dataSource?.[0]?.active !== true && (
              <Button
                type="primary"
                // htmlType="submit"
                onClick={() => {
                  handleActive()
                }}
              >
                <PlusOutlined />
                Active
              </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa thông báo'
            : mode == 'ADD'
            ? 'Thêm mới footer'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost
          form={form}
          handleSearch={handleSearch}
          mode={mode}
          postType={postType}
          ProductType={ProductType}
          typeRealEstate={typeRealEstate}
          // Render loại hình BĐS theo loại BĐS
          districts={districts}
          towns={towns}
          onChangePostType={onChangePostType}
          onChangeDistrict={onChangeDistrict}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default TableB
